<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.81163 13.0828L15.4016 13.0828L12.1016 16.3728C11.9133 16.5611 11.8075 16.8165 11.8075 17.0828C11.8075 17.3491 11.9133 17.6045 12.1016 17.7928C12.2899 17.9811 12.5453 18.0869 12.8116 18.0869C13.0779 18.0869 13.3333 17.9811 13.5216 17.7928L18.5216 12.7928C18.6127 12.6977 18.684 12.5855 18.7316 12.4628C18.8316 12.2193 18.8316 11.9462 18.7316 11.7028C18.684 11.58 18.6127 11.4679 18.5216 11.3728L13.5216 6.37276C13.4287 6.27903 13.3181 6.20464 13.1962 6.15387C13.0743 6.1031 12.9436 6.07696 12.8116 6.07696C12.6796 6.07696 12.5489 6.1031 12.4271 6.15387C12.3052 6.20464 12.1946 6.27903 12.1016 6.37276C12.0079 6.46573 11.9335 6.57632 11.8827 6.69818C11.832 6.82004 11.8058 6.95075 11.8058 7.08276C11.8058 7.21477 11.832 7.34548 11.8827 7.46734C11.9335 7.5892 12.0079 7.6998 12.1016 7.79276L15.4016 11.0828L7.81163 11.0828C7.54641 11.0828 7.29206 11.1881 7.10452 11.3757C6.91698 11.5632 6.81163 11.8175 6.81163 12.0828C6.81163 12.348 6.91698 12.6023 7.10452 12.7899C7.29206 12.9774 7.54641 13.0828 7.81163 13.0828Z"
      fill="#6400FF"
    />
  </svg>
</template>

<script>
export default {
  name: 'PurpleNextIcon',
};
</script>
